/* eslint-disable angular/module-getter */
// Provides a shared place to broadcast global actions such as Save, Apply, etc.

// List of all actions that have keys
import { stopEvent } from '../../utils/event-utils';
import { ucFirst } from '../../utils/string-utils';

export const GLOBAL_ACTION_KEYS = {
  'Command-Shift-s': 'save',
  'Command-s': 'apply',
  'Command-p': 'preview',
  'Command-?': 'help',
  'Command-enter': 'run',
  "Command-'": 'test',
};

// List of all actions (could include some that don't have keys)
export const GLOBAL_ACTIONS = Object.values(GLOBAL_ACTION_KEYS);

export const GLOBAL_ACTION_PREFIX = 'globalAction:';

export const GLOBAL_ACTION_EVENTS = {};

export const globalActionsComponentModule = angular.module(
  'Q.services.global-actions-component',
  [],
);

/**
 * @ngdoc directive
 * @name globalActionSave
 *
 * @description
 * Performs the specified action when a save event is triggered
 *
 * @element ANY
 * @restrict A
 * @param {expression} globalActionSave {@link guide/expression Expression} to evaluate
 */

/**
 * @ngdoc directive
 * @name globalActionApply
 *
 * @description
 * Performs the specified action when an apply event is triggered
 *
 * @element ANY
 * @restrict A
 * @param {expression} globalActionApply {@link guide/expression Expression} to evaluate
 */

/**
 * @ngdoc directive
 * @name globalActionPreview
 *
 * @description
 * Performs the specified action when a preview event is triggered
 *
 * @element ANY
 * @restrict A
 * @param {expression} globalActionPreview {@link guide/expression Expression} to evaluate
 */

/**
 * @ngdoc directive
 * @name globalActionHelp
 *
 * @description
 * Performs the specified action when a help event is triggered
 *
 * @element ANY
 * @restrict A
 * @param {expression} globalActionHelp {@link guide/expression Expression} to evaluate
 */

/**
 * @ngdoc directive
 * @name globalActionRun
 *
 * @description
 * Performs the specified action when a run event is triggered
 *
 * @element ANY
 * @restrict A
 * @param {expression} globalActionRun {@link guide/expression Expression} to evaluate
 */

GLOBAL_ACTIONS.forEach((action) => {
  GLOBAL_ACTION_EVENTS[action] = GLOBAL_ACTION_PREFIX + action;

  const directiveName = `globalAction${ucFirst(action)}`;
  globalActionsComponentModule.directive(directiveName, function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$on(GLOBAL_ACTION_EVENTS[action], ($event) => {
          stopEvent($event);
          scope.$evalAsync(attrs[directiveName], { $event });
        });
      },
    };
  });
});

globalActionsComponentModule.factory(
  'globalActionsService',
  function ($rootScope) {
    function trigger(action, ...args) {
      return $rootScope.$broadcast(GLOBAL_ACTION_EVENTS[action], ...args)
        .defaultPrevented;
    }

    const svc = {};
    GLOBAL_ACTIONS.forEach((action) => {
      svc[action] = trigger.bind(null, action);
    });

    return svc;
  },
);
